module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Randa-d1a5f06d4609ee0733e54291616dbacf.png";